/**
 * Generated from PostcardBeijing1Layout.fla
 */
export function PostcardBeijing1Layout(this: IPostcardBeijing1Layout) {
	const main = this.main;
	PostcardBeijing1Layout_main.call(this.main);
	main.x = 1024;
	main.y = 768;
	if (main.onLayout) main.onLayout();
	return this;
}
export function PostcardBeijing1Layout_main(this: IPostcardBeijing1Layout_main) {
	const postcard = this.postcard;
	PostcardBeijing1Layout_postcard.call(this.postcard);
	postcard.x = 0;
	postcard.y = 4.7;
	if (postcard.scale) postcard.scale.x = 0.633;
	if (postcard.scale) postcard.scale.y = 0.633;
	if (postcard.onLayout) postcard.onLayout();
	return this;
}
function PostcardBeijing1Layout_postcard(this: IPostcardBeijing1Layout_postcard) {
	const cardTransform = this.cardTransform;
	if (!cardTransform[0] && cardTransform.elementFactory) {
		cardTransform[0] = cardTransform.elementFactory(0,undefined);
	}
	if (cardTransform[0]) {
		PostcardBeijing1Layout_cardTransform1.call(cardTransform[0] as IPostcardBeijing1Layout_cardTransform1);
		cardTransform[0].x = -375.65;
		cardTransform[0].y = 321.2;
		cardTransform[0].width = 528.41;
		cardTransform[0].height = 662.35;
		if (cardTransform[0].onLayout) cardTransform[0].onLayout();
	}
	if (!cardTransform[1] && cardTransform.elementFactory) {
		cardTransform[1] = cardTransform.elementFactory(1,undefined);
	}
	if (cardTransform[1]) {
		PostcardBeijing1Layout_cardTransform2.call(cardTransform[1] as IPostcardBeijing1Layout_cardTransform2);
		cardTransform[1].x = 570.3;
		cardTransform[1].y = 269.8;
		cardTransform[1].width = 540.72;
		cardTransform[1].height = 677.78;
		if (cardTransform[1].onLayout) cardTransform[1].onLayout();
	}
	if (!cardTransform[2] && cardTransform.elementFactory) {
		cardTransform[2] = cardTransform.elementFactory(2,undefined);
	}
	if (cardTransform[2]) {
		PostcardBeijing1Layout_cardTransform3.call(cardTransform[2] as IPostcardBeijing1Layout_cardTransform3);
		cardTransform[2].x = 671.85;
		cardTransform[2].y = -214.55;
		cardTransform[2].width = 453.79;
		cardTransform[2].height = 568.82;
		if (cardTransform[2].onLayout) cardTransform[2].onLayout();
	}
	if (!cardTransform[3] && cardTransform.elementFactory) {
		cardTransform[3] = cardTransform.elementFactory(3,undefined);
	}
	if (cardTransform[3]) {
		PostcardBeijing1Layout_cardTransform4.call(cardTransform[3] as IPostcardBeijing1Layout_cardTransform4);
		cardTransform[3].x = -659;
		cardTransform[3].y = -365.05;
		cardTransform[3].width = 332.70;
		cardTransform[3].height = 417.03;
		if (cardTransform[3].onLayout) cardTransform[3].onLayout();
	}
	if (!cardTransform[4] && cardTransform.elementFactory) {
		cardTransform[4] = cardTransform.elementFactory(4,undefined);
	}
	if (cardTransform[4]) {
		PostcardBeijing1Layout_cardTransform5.call(cardTransform[4] as IPostcardBeijing1Layout_cardTransform5);
		cardTransform[4].x = 304.4;
		cardTransform[4].y = -58.6;
		cardTransform[4].width = 589.69;
		cardTransform[4].height = 739.16;
		if (cardTransform[4].onLayout) cardTransform[4].onLayout();
	}
	if (!cardTransform[5] && cardTransform.elementFactory) {
		cardTransform[5] = cardTransform.elementFactory(5,undefined);
	}
	if (cardTransform[5]) {
		PostcardBeijing1Layout_cardTransform6.call(cardTransform[5] as IPostcardBeijing1Layout_cardTransform6);
		cardTransform[5].x = -406.55;
		cardTransform[5].y = -330.85;
		cardTransform[5].width = 474.36;
		cardTransform[5].height = 594.60;
		if (cardTransform[5].onLayout) cardTransform[5].onLayout();
	}
	if (!cardTransform[6] && cardTransform.elementFactory) {
		cardTransform[6] = cardTransform.elementFactory(6,undefined);
	}
	if (cardTransform[6]) {
		PostcardBeijing1Layout_cardTransform7.call(cardTransform[6] as IPostcardBeijing1Layout_cardTransform7);
		cardTransform[6].x = -635;
		cardTransform[6].y = -56.55;
		cardTransform[6].width = 455.78;
		cardTransform[6].height = 571.31;
		if (cardTransform[6].onLayout) cardTransform[6].onLayout();
	}
	if (!cardTransform[7] && cardTransform.elementFactory) {
		cardTransform[7] = cardTransform.elementFactory(7,undefined);
	}
	if (cardTransform[7]) {
		PostcardBeijing1Layout_cardTransform8.call(cardTransform[7] as IPostcardBeijing1Layout_cardTransform8);
		cardTransform[7].x = -87.55;
		cardTransform[7].y = 103.1;
		cardTransform[7].width = 260.44;
		cardTransform[7].height = 326.45;
		if (cardTransform[7].onLayout) cardTransform[7].onLayout();
	}
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[0]) {
		PostcardBeijing1Layout_pieces3.call(items[0] as IPostcardBeijing1Layout_pieces3);
		(items[0] as IPostcardBeijing1Layout_pieces3).dependsOn = 0;
		(items[0] as IPostcardBeijing1Layout_pieces3).outlineGlow = true;
		items[0].x = 682.1;
		items[0].y = -122.2;
		items[0].width = 710.00;
		items[0].height = 523.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		PostcardBeijing1Layout_outlines3.call(items[1] as IPostcardBeijing1Layout_outlines3);
		items[1].x = 661.55;
		items[1].y = -262;
		items[1].width = 407.00;
		items[1].height = 424.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		PostcardBeijing1Layout_pieces6.call(items[2] as IPostcardBeijing1Layout_pieces6);
		items[2].x = -398;
		items[2].y = -285.1;
		items[2].width = 230.00;
		items[2].height = 586.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		PostcardBeijing1Layout_outlines6.call(items[3] as IPostcardBeijing1Layout_outlines6);
		items[3].x = -396;
		items[3].y = -287.3;
		items[3].width = 223.00;
		items[3].height = 579.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		PostcardBeijing1Layout_decorationBeijing11.call(items[4] as IPostcardBeijing1Layout_decorationBeijing11);
		items[4].x = 130.25;
		items[4].y = 105.85;
		items[4].width = 1732.00;
		items[4].height = 424.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,undefined);
	}
	if (items[5]) {
		PostcardBeijing1Layout_pieces4.call(items[5] as IPostcardBeijing1Layout_pieces4);
		items[5].x = -656.1;
		items[5].y = -409.8;
		items[5].width = 245.00;
		items[5].height = 763.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,undefined);
	}
	if (items[6]) {
		PostcardBeijing1Layout_outlines4.call(items[6] as IPostcardBeijing1Layout_outlines4);
		items[6].x = -648.2;
		items[6].y = -407.45;
		items[6].width = 230.00;
		items[6].height = 183.00;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,undefined);
	}
	if (items[7]) {
		PostcardBeijing1Layout_decorationBeijing13.call(items[7] as IPostcardBeijing1Layout_decorationBeijing13);
		items[7].x = -94.8;
		items[7].y = -85.2;
		items[7].width = 413.00;
		items[7].height = 652.00;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,undefined);
	}
	if (items[8]) {
		PostcardBeijing1Layout_pieces7.call(items[8] as IPostcardBeijing1Layout_pieces7);
		items[8].x = -627.15;
		items[8].y = -10.85;
		items[8].width = 399.00;
		items[8].height = 500.00;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,undefined);
	}
	if (items[9]) {
		PostcardBeijing1Layout_outlines7.call(items[9] as IPostcardBeijing1Layout_outlines7);
		items[9].x = -628.45;
		items[9].y = -9.45;
		items[9].width = 397.00;
		items[9].height = 501.00;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,undefined);
	}
	if (items[10]) {
		PostcardBeijing1Layout_pieces5.call(items[10] as IPostcardBeijing1Layout_pieces5);
		items[10].x = 315.15;
		items[10].y = -76.2;
		items[10].width = 440.00;
		items[10].height = 594.00;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,undefined);
	}
	if (items[11]) {
		PostcardBeijing1Layout_outlines5.call(items[11] as IPostcardBeijing1Layout_outlines5);
		items[11].x = 315.75;
		items[11].y = -75.7;
		items[11].width = 442.00;
		items[11].height = 595.00;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,undefined);
	}
	if (items[12]) {
		PostcardBeijing1Layout_pieces8.call(items[12] as IPostcardBeijing1Layout_pieces8);
		items[12].x = -86.85;
		items[12].y = 103.65;
		items[12].width = 169.00;
		items[12].height = 175.00;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,undefined);
	}
	if (items[13]) {
		PostcardBeijing1Layout_outlines8.call(items[13] as IPostcardBeijing1Layout_outlines8);
		items[13].x = -86.55;
		items[13].y = 103.45;
		items[13].width = 166.00;
		items[13].height = 176.00;
		if (items[13].onLayout) items[13].onLayout();
	}
	if (!items[14] && items.elementFactory) {
		items[14] = items.elementFactory(14,undefined);
	}
	if (items[14]) {
		PostcardBeijing1Layout_decorationBeijing12.call(items[14] as IPostcardBeijing1Layout_decorationBeijing12);
		items[14].x = -4.6;
		items[14].y = 269;
		items[14].width = 1728.00;
		items[14].height = 159.00;
		if (items[14].onLayout) items[14].onLayout();
	}
	if (!items[15] && items.elementFactory) {
		items[15] = items.elementFactory(15,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[15]) {
		PostcardBeijing1Layout_pieces1.call(items[15] as IPostcardBeijing1Layout_pieces1);
		(items[15] as IPostcardBeijing1Layout_pieces1).dependsOn = 0;
		(items[15] as IPostcardBeijing1Layout_pieces1).outlineGlow = true;
		items[15].x = -379.25;
		items[15].y = 361.2;
		items[15].width = 423.00;
		items[15].height = 341.00;
		if (items[15].onLayout) items[15].onLayout();
	}
	if (!items[16] && items.elementFactory) {
		items[16] = items.elementFactory(16,undefined);
	}
	if (items[16]) {
		PostcardBeijing1Layout_outlines1.call(items[16] as IPostcardBeijing1Layout_outlines1);
		items[16].x = -372.65;
		items[16].y = 357.05;
		items[16].width = 406.00;
		items[16].height = 329.00;
		if (items[16].onLayout) items[16].onLayout();
	}
	if (!items[17] && items.elementFactory) {
		items[17] = items.elementFactory(17,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[17]) {
		PostcardBeijing1Layout_pieces2.call(items[17] as IPostcardBeijing1Layout_pieces2);
		(items[17] as IPostcardBeijing1Layout_pieces2).dependsOn = 0;
		(items[17] as IPostcardBeijing1Layout_pieces2).outlineGlow = true;
		items[17].x = 568.95;
		items[17].y = 276.55;
		items[17].width = 392.99;
		items[17].height = 462.99;
		if (items[17].onLayout) items[17].onLayout();
	}
	if (!items[18] && items.elementFactory) {
		items[18] = items.elementFactory(18,undefined);
	}
	if (items[18]) {
		PostcardBeijing1Layout_outlines2.call(items[18] as IPostcardBeijing1Layout_outlines2);
		items[18].x = 569.2;
		items[18].y = 275.25;
		items[18].width = 394.00;
		items[18].height = 458.00;
		if (items[18].onLayout) items[18].onLayout();
	}
	const shapes = this.shapes;
	if (!shapes[0] && shapes.elementFactory) {
		shapes[0] = shapes.elementFactory(0,undefined);
	}
	if (shapes[0]) {
		shapes[0] = [5.00,0.00];
	}
	if (!shapes[1] && shapes.elementFactory) {
		shapes[1] = shapes.elementFactory(1,undefined);
	}
	if (shapes[1]) {
		shapes[1] = [10.00,0.00];
	}
	if (!shapes[2] && shapes.elementFactory) {
		shapes[2] = shapes.elementFactory(2,undefined);
	}
	if (shapes[2]) {
		shapes[2] = [775.45,-480.75,820.95,-356.80,864.15,-216.30,864.90,16.75,419.20,18.30,415.30,-221.80,437.25,-263.40,483.55,-297.90,554.45,-293.35,708.00,-295.50,710.35,-360.70,746.45,-479.20];
	}
	const background = this.background;
	PostcardBeijing1Layout_background.call(this.background);
	background.x = 0;
	background.y = 0;
	background.width = 1790.00;
	background.height = 1325.00;
	if (background.onLayout) background.onLayout();
	const postcardOverlay = this.postcardOverlay;
	PostcardBeijing1Layout_postcardOverlay.call(this.postcardOverlay);
	postcardOverlay.x = 0;
	postcardOverlay.y = 0;
	postcardOverlay.width = 1784.00;
	postcardOverlay.height = 1318.00;
	if (postcardOverlay.onLayout) postcardOverlay.onLayout();
	const postcardMask = this.postcardMask;
	postcardMask.push(11.60,-642.40,878.60,-641.10,869.70,11.90,875.65,626.30,29.70,629.25,-492.65,638.15,-880.20,652.65,-875.55,-47.50,-881.50,-655.95);
	return this;
}
function PostcardBeijing1Layout_background(this: IPostcardBeijing1Layout_background) {
	if (this.setLayoutTexture) this.setLayoutTexture("postcard-beijing-1.png", 0.500, 0.500);
	return this;
}
function PostcardBeijing1Layout_cardTransform6(this: IPostcardBeijing1Layout_cardTransform6) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-beijing-1-6.png", 0.500, 0.501);
	return this;
}
function PostcardBeijing1Layout_cardTransform5(this: IPostcardBeijing1Layout_cardTransform5) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-beijing-1-5.png", 0.500, 0.501);
	return this;
}
function PostcardBeijing1Layout_cardTransform4(this: IPostcardBeijing1Layout_cardTransform4) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-beijing-1-4.png", 0.500, 0.501);
	return this;
}
function PostcardBeijing1Layout_cardTransform3(this: IPostcardBeijing1Layout_cardTransform3) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-beijing-1-3.png", 0.500, 0.501);
	return this;
}
function PostcardBeijing1Layout_cardTransform1(this: IPostcardBeijing1Layout_cardTransform1) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-beijing-1-1.png", 0.500, 0.501);
	return this;
}
function PostcardBeijing1Layout_cardTransform2(this: IPostcardBeijing1Layout_cardTransform2) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-beijing-1-2.png", 0.500, 0.501);
	return this;
}
function PostcardBeijing1Layout_cardTransform7(this: IPostcardBeijing1Layout_cardTransform7) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-beijing-1-7.png", 0.500, 0.501);
	return this;
}
function PostcardBeijing1Layout_cardTransform8(this: IPostcardBeijing1Layout_cardTransform8) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-beijing-1-8.png", 0.500, 0.501);
	return this;
}
function PostcardBeijing1Layout_pieces3(this: IPostcardBeijing1Layout_pieces3) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-beijing-1-3.png", 0.720, 0.675);
	return this;
}
function PostcardBeijing1Layout_outlines3(this: IPostcardBeijing1Layout_outlines3) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-beijing-1-3.png", 0.501, 0.500);
	return this;
}
function PostcardBeijing1Layout_pieces6(this: IPostcardBeijing1Layout_pieces6) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-beijing-1-6.png", 0.500, 0.500);
	return this;
}
function PostcardBeijing1Layout_outlines6(this: IPostcardBeijing1Layout_outlines6) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-beijing-1-6.png", 0.502, 0.501);
	return this;
}
function PostcardBeijing1Layout_decorationBeijing11(this: IPostcardBeijing1Layout_decorationBeijing11) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-beijing-1-1.png", 0.577, 0.500);
	return this;
}
function PostcardBeijing1Layout_pieces4(this: IPostcardBeijing1Layout_pieces4) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-beijing-1-4.png", 0.498, 0.144);
	return this;
}
function PostcardBeijing1Layout_outlines4(this: IPostcardBeijing1Layout_outlines4) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-beijing-1-4.png", 0.500, 0.503);
	return this;
}
function PostcardBeijing1Layout_decorationBeijing13(this: IPostcardBeijing1Layout_decorationBeijing13) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-beijing-1-3.png", 0.500, 0.500);
	return this;
}
function PostcardBeijing1Layout_pieces7(this: IPostcardBeijing1Layout_pieces7) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-beijing-1-7.png", 0.501, 0.500);
	return this;
}
function PostcardBeijing1Layout_outlines7(this: IPostcardBeijing1Layout_outlines7) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-beijing-1-7.png", 0.501, 0.501);
	return this;
}
function PostcardBeijing1Layout_pieces5(this: IPostcardBeijing1Layout_pieces5) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-beijing-1-5.png", 0.500, 0.500);
	return this;
}
function PostcardBeijing1Layout_outlines5(this: IPostcardBeijing1Layout_outlines5) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-beijing-1-5.png", 0.500, 0.501);
	return this;
}
function PostcardBeijing1Layout_pieces8(this: IPostcardBeijing1Layout_pieces8) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-beijing-1-8.png", 0.503, 0.503);
	return this;
}
function PostcardBeijing1Layout_outlines8(this: IPostcardBeijing1Layout_outlines8) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-beijing-1-8.png", 0.500, 0.500);
	return this;
}
function PostcardBeijing1Layout_decorationBeijing12(this: IPostcardBeijing1Layout_decorationBeijing12) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-beijing-1-2.png", 0.500, 0.503);
	return this;
}
function PostcardBeijing1Layout_pieces1(this: IPostcardBeijing1Layout_pieces1) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-beijing-1-1.png", 0.501, 0.501);
	return this;
}
function PostcardBeijing1Layout_outlines1(this: IPostcardBeijing1Layout_outlines1) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-beijing-1-1.png", 0.500, 0.502);
	return this;
}
function PostcardBeijing1Layout_pieces2(this: IPostcardBeijing1Layout_pieces2) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-beijing-1-2.png", 0.501, 0.501);
	return this;
}
function PostcardBeijing1Layout_outlines2(this: IPostcardBeijing1Layout_outlines2) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-beijing-1-2.png", 0.500, 0.500);
	return this;
}
function PostcardBeijing1Layout_shapes2(this: IPostcardBeijing1Layout_shapes2) {
	return this;
}
function PostcardBeijing1Layout_shapes3(this: IPostcardBeijing1Layout_shapes3) {
	return this;
}
function PostcardBeijing1Layout_shapes1(this: IPostcardBeijing1Layout_shapes1) {
	return this;
}
function PostcardBeijing1Layout_postcardOverlay(this: IPostcardBeijing1Layout_postcardOverlay) {
	if (this.setLayoutTexture) this.setLayoutTexture("postcard-border.png", 0.500, 0.500);
	return this;
}
function PostcardBeijing1Layout_postcardMask(this: IPostcardBeijing1Layout_postcardMask) {
	return this;
}
interface IPostcardBeijing1LayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IPostcardBeijing1LayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IPostcardBeijing1LayoutSprite extends IPostcardBeijing1LayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IPostcardBeijing1LayoutText extends IPostcardBeijing1LayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IPostcardBeijing1LayoutPolygon extends Array<number> {
}
interface IPostcardBeijing1Layout {
	readonly main: IPostcardBeijing1Layout_main;
}
interface IPostcardBeijing1Layout_main extends IPostcardBeijing1LayoutContainer {
	readonly postcard: IPostcardBeijing1Layout_postcard;
}
interface IPostcardBeijing1Layout_postcard extends IPostcardBeijing1LayoutContainer {
	readonly cardTransform: IPostcardBeijing1LayoutArray<IPostcardBeijing1Layout_cardTransform1|IPostcardBeijing1Layout_cardTransform2|IPostcardBeijing1Layout_cardTransform3|IPostcardBeijing1Layout_cardTransform4|IPostcardBeijing1Layout_cardTransform5|IPostcardBeijing1Layout_cardTransform6|IPostcardBeijing1Layout_cardTransform7|IPostcardBeijing1Layout_cardTransform8>;
	readonly items: IPostcardBeijing1LayoutArray<IPostcardBeijing1Layout_pieces3|IPostcardBeijing1Layout_outlines3|IPostcardBeijing1Layout_pieces6|IPostcardBeijing1Layout_outlines6|IPostcardBeijing1Layout_decorationBeijing11|IPostcardBeijing1Layout_pieces4|IPostcardBeijing1Layout_outlines4|IPostcardBeijing1Layout_decorationBeijing13|IPostcardBeijing1Layout_pieces7|IPostcardBeijing1Layout_outlines7|IPostcardBeijing1Layout_pieces5|IPostcardBeijing1Layout_outlines5|IPostcardBeijing1Layout_pieces8|IPostcardBeijing1Layout_outlines8|IPostcardBeijing1Layout_decorationBeijing12|IPostcardBeijing1Layout_pieces1|IPostcardBeijing1Layout_outlines1|IPostcardBeijing1Layout_pieces2|IPostcardBeijing1Layout_outlines2>;
	readonly shapes: IPostcardBeijing1LayoutArray<IPostcardBeijing1Layout_shapes1|IPostcardBeijing1Layout_shapes2|IPostcardBeijing1Layout_shapes3>;
	readonly background: IPostcardBeijing1Layout_background;
	readonly postcardOverlay: IPostcardBeijing1Layout_postcardOverlay;
	readonly postcardMask: IPostcardBeijing1Layout_postcardMask;
}
interface IPostcardBeijing1Layout_background extends IPostcardBeijing1LayoutSprite {
}
interface IPostcardBeijing1Layout_cardTransform6 extends IPostcardBeijing1LayoutSprite {
}
interface IPostcardBeijing1Layout_cardTransform5 extends IPostcardBeijing1LayoutSprite {
}
interface IPostcardBeijing1Layout_cardTransform4 extends IPostcardBeijing1LayoutSprite {
}
interface IPostcardBeijing1Layout_cardTransform3 extends IPostcardBeijing1LayoutSprite {
}
interface IPostcardBeijing1Layout_cardTransform1 extends IPostcardBeijing1LayoutSprite {
}
interface IPostcardBeijing1Layout_cardTransform2 extends IPostcardBeijing1LayoutSprite {
}
interface IPostcardBeijing1Layout_cardTransform7 extends IPostcardBeijing1LayoutSprite {
}
interface IPostcardBeijing1Layout_cardTransform8 extends IPostcardBeijing1LayoutSprite {
}
interface IPostcardBeijing1Layout_pieces3 extends IPostcardBeijing1LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardBeijing1Layout_outlines3 extends IPostcardBeijing1LayoutSprite {
}
interface IPostcardBeijing1Layout_pieces6 extends IPostcardBeijing1LayoutSprite {
}
interface IPostcardBeijing1Layout_outlines6 extends IPostcardBeijing1LayoutSprite {
}
interface IPostcardBeijing1Layout_decorationBeijing11 extends IPostcardBeijing1LayoutSprite {
}
interface IPostcardBeijing1Layout_pieces4 extends IPostcardBeijing1LayoutSprite {
}
interface IPostcardBeijing1Layout_outlines4 extends IPostcardBeijing1LayoutSprite {
}
interface IPostcardBeijing1Layout_decorationBeijing13 extends IPostcardBeijing1LayoutSprite {
}
interface IPostcardBeijing1Layout_pieces7 extends IPostcardBeijing1LayoutSprite {
}
interface IPostcardBeijing1Layout_outlines7 extends IPostcardBeijing1LayoutSprite {
}
interface IPostcardBeijing1Layout_pieces5 extends IPostcardBeijing1LayoutSprite {
}
interface IPostcardBeijing1Layout_outlines5 extends IPostcardBeijing1LayoutSprite {
}
interface IPostcardBeijing1Layout_pieces8 extends IPostcardBeijing1LayoutSprite {
}
interface IPostcardBeijing1Layout_outlines8 extends IPostcardBeijing1LayoutSprite {
}
interface IPostcardBeijing1Layout_decorationBeijing12 extends IPostcardBeijing1LayoutSprite {
}
interface IPostcardBeijing1Layout_pieces1 extends IPostcardBeijing1LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardBeijing1Layout_outlines1 extends IPostcardBeijing1LayoutSprite {
}
interface IPostcardBeijing1Layout_pieces2 extends IPostcardBeijing1LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardBeijing1Layout_outlines2 extends IPostcardBeijing1LayoutSprite {
}
interface IPostcardBeijing1Layout_shapes2 extends IPostcardBeijing1LayoutPolygon {
}
interface IPostcardBeijing1Layout_shapes3 extends IPostcardBeijing1LayoutPolygon {
}
interface IPostcardBeijing1Layout_shapes1 extends IPostcardBeijing1LayoutPolygon {
}
interface IPostcardBeijing1Layout_postcardOverlay extends IPostcardBeijing1LayoutSprite {
}
interface IPostcardBeijing1Layout_postcardMask extends IPostcardBeijing1LayoutPolygon {
}
